(function(){
  var bar=document.querySelector('[data-ev-sticky]'); if(!bar) return;
  var product=JSON.parse(bar.querySelector('[data-ev-sticky-product]').textContent);
  var main=document.querySelector('[data-section-type="product"]')||document;
  var form=main.querySelector('form[action*="/cart/add"]');
  var atc=main.querySelector('[data-add-to-cart]')||(form&&form.querySelector('[type="submit"]'));
  if(!form||!atc){return}
  var sels=[].slice.call(bar.querySelectorAll('[data-ev-sticky-opt]'));
  var qtyEl=bar.querySelector('[data-ev-sticky-qty]'), btn=bar.querySelector('[data-ev-sticky-add]'), priceEl=bar.querySelector('[data-ev-sticky-price]');
  var qty=1;
  var money=function(c){return new Intl.NumberFormat('en-AU',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'AUD'}).format(c/100)};
  function currentId(){var i=form.querySelector('[name="id"]');return i?+i.value:null}
  function variantById(id){return product.variants.find(function(v){return v.id===id})}
  function variantByOpts(){var o=sels.map(function(s){return s.value});return product.variants.find(function(v){return v.options.every(function(x,i){return x===o[i]})})}
  function paint(v){
    if(!v){btn.disabled=true;btn.textContent='Unavailable';return}
    priceEl.textContent=money(v.price);
    btn.disabled=!v.available;btn.textContent=v.available?'Add to cart':'Sold out';
  }
  function fromMain(){var v=variantById(currentId());if(v){sels.forEach(function(s,i){s.value=v.options[i]})}paint(v)}
  function toMain(){
    var v=variantByOpts();paint(v);
    sels.forEach(function(s,i){
      var r=main.querySelector('input[data-single-option-selector][data-index="option'+(i+1)+'"][value="'+CSS.escape(s.value)+'"]');
      if(r&&!r.checked){r.checked=true;r.dispatchEvent(new Event('change',{bubbles:true}))}
    });
  }
  sels.forEach(function(s){s.addEventListener('change',toMain)});
  main.addEventListener('change',function(e){if(e.target.matches('[data-single-option-selector],[name="id"]'))setTimeout(fromMain,60)});
  bar.querySelector('[data-ev-sticky-inc]').addEventListener('click',function(){qty++;qtyEl.textContent=qty});
  bar.querySelector('[data-ev-sticky-dec]').addEventListener('click',function(){qty=Math.max(1,qty-1);qtyEl.textContent=qty});
  btn.addEventListener('click',function(){
    var v=variantByOpts()||variantById(currentId()); if(!v||!v.available)return;
    btn.disabled=true;var t=btn.textContent;btn.textContent='Adding…';
    fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:v.id,quantity:qty}]})})
      .then(function(r){return r.json()}).then(function(){if(window.EVCart)EVCart.open();else location.href='/cart'})
      .finally(function(){btn.disabled=false;btn.textContent=t;paint(v)});
  });
  bar.hidden=false;
  var io=new IntersectionObserver(function(en){var e=en[0];var past=!e.isIntersecting&&e.boundingClientRect.top<0;bar.classList.toggle('is-visible',past);bar.setAttribute('aria-hidden',past?'false':'true')},{threshold:0});
  io.observe(atc);
  fromMain();
})();
